"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.type.target': 'Cel',
    'slotData.type.goal': 'Zadanie',
};
